// Add this helper function at the top of your component or in a utils file
export const getRandomImage = (images) => {
  if (!images) return null;
  if (typeof images === 'string') return images;
  if (Array.isArray(images) && images.length > 0) {
    return images[Math.floor(Math.random() * images.length)];
  }
  return null;
};
